import { useCheckPermissions } from '@/modules/auth/hooks/useCheckPermissions';
import { permissions } from '@/modules/auth/permissions';
import { useWorkspacePlan } from '@/modules/billing/hooks/useWorkspacePlan';
import type { JobApi } from '@/modules/jobs/types';
import { automationFromJob } from '@/pages/hm/job-automation/jobAutomation';

/**
 * The customer does the outreach on this job and may draft and send it:
 * drafting needs messaging write; reviewing the drafts needs read. Managed
 * customers cannot connect LinkedIn (see HMIntegrations), so their
 * recruiter's outreach never asks them to.
 */
export const useIsManualOutreach = (job: JobApi | undefined) => {
  const hasPermission = useCheckPermissions();
  const { plan, isLoading, error } = useWorkspacePlan();
  return (
    job !== undefined &&
    !isLoading &&
    !error &&
    plan !== 'managed' &&
    automationFromJob(job).outreach === 'me' &&
    hasPermission([permissions.Messaging.Read, permissions.Messaging.Write])
  );
};
